import * as ActionTypes from '../../actions/actionTypes'

const initialState = {
    pendingPushYearPrices: false,
    pendingPushYearRestrictions: false,
    pendingInventoryAvailability: false,
    pendingInventoryOrder: false,
    pendingOtelmsInventory: false,
    pendingLoadBasedOnReservationSummary: false
}

/** @reducer **/
export default (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.B_PUSH_YEAR_PRICES_REQUEST:
            return { ...state, pendingPushYearPrices: true }
        case ActionTypes.B_PUSH_YEAR_PRICES_SUCCESS:
        case ActionTypes.B_PUSH_YEAR_PRICES_FAILURE:
            return { ...state, pendingPushYearPrices: false }

        case ActionTypes.B_PUSH_YEAR_RESTRICTIONS_REQUEST:
            return { ...state, pendingPushYearRestrictions: true }
        case ActionTypes.B_PUSH_YEAR_RESTRICTIONS_SUCCESS:
        case ActionTypes.B_PUSH_YEAR_RESTRICTIONS_FAILURE:
            return { ...state, pendingPushYearRestrictions: false }

        case ActionTypes.B_INVENTORY_AVAILABILITY_REQUEST:
            return { ...state, pendingInventoryAvailability: true }
        case ActionTypes.B_INVENTORY_AVAILABILITY_SUCCESS:
        case ActionTypes.B_INVENTORY_AVAILABILITY_FAILURE:
            return { ...state, pendingInventoryAvailability: false }

        case ActionTypes.B_INVENTORY_ORDER_REQUEST:
            return { ...state, pendingInventoryOrder: true }
        case ActionTypes.B_INVENTORY_ORDER_SUCCESS:
        case ActionTypes.B_INVENTORY_ORDER_FAILURE:
            return { ...state, pendingInventoryOrder: false }

        case ActionTypes.B_INVENTORY_OTELMS_REQUEST:
            return { ...state, pendingOtelmsInventory: true }
        case ActionTypes.B_INVENTORY_OTELMS_SUCCESS:
        case ActionTypes.B_INVENTORY_OTELMS_FAILURE:
            return { ...state, pendingOtelmsInventory: false }

        case ActionTypes.B_LOAD_BASED_ON_RESERVATION_SUMMARY_REQUEST:
            return { ...state, pendingLoadBasedOnReservationSummary: true }
        case ActionTypes.B_LOAD_BASED_ON_RESERVATION_SUMMARY_SUCCESS:
        case ActionTypes.B_LOAD_BASED_ON_RESERVATION_SUMMARY_FAILURE:
            return { ...state, pendingLoadBasedOnReservationSummary: false }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/bookingReducers/bookingSync.js